import React from 'react';

import PropTypes from 'prop-types';

import { useEnableSideBySideRateBrowser } from '../../../feature-flags/hooks/use-enable-side-by-side-rate-browser';
import { RateBrowserShipmentConfigurationPropType } from '../../../prop-types/rate-browser-shipment-configuration';
import { NewRateViewer, OldRateViewer } from '../../rate-viewer';
import { RateViewerContextProvider } from '../../rate-viewer/rate-viewer-context-provider';
import { RateBrowserConfigurationFormContainer } from '../rate-browser-modal/configuration-form/container';
import { RateBrowserConfigurationFormContextContainer } from '../rate-browser-modal/configuration-form/context-container';

import style from './rate-viewer-modal.module.less';

export const RateViewerLoader = ({ onBrowseRates, onConfigureLabel, rateViewerKey, shipmentConfiguration, onScaleRead }) => {
  const enableSideBySideRateBrowser = useEnableSideBySideRateBrowser();

  return enableSideBySideRateBrowser ? (
    <RateViewerContextProvider
      onBrowseRates={onBrowseRates}
      onConfigureLabel={onConfigureLabel}
      rateViewerKey={rateViewerKey}
      shipmentConfiguration={shipmentConfiguration}
    >
      <div className={style['left-side-wrapper']}>
        <RateBrowserConfigurationFormContextContainer isFromCSWRateBrowserClick onScaleRead={onScaleRead} />
      </div>
      <div className={style['rate-list-wrapper']}>
        <NewRateViewer />
      </div>
    </RateViewerContextProvider>
  ) : (
    <>
      <div className={style['left-side-wrapper']}>
        <RateBrowserConfigurationFormContainer
          isFromCSWRateBrowserClick
          onBrowseRates={onBrowseRates}
          onScaleRead={onScaleRead}
          rateViewerKey={rateViewerKey}
        />
      </div>
      <div className={style['rate-list-wrapper']}>
        <OldRateViewer buttonTheme='primary' onConfigureLabel={onConfigureLabel} rateViewerKey={rateViewerKey} />
      </div>
    </>
  );
};

RateViewerLoader.propTypes = {
  onBrowseRates: PropTypes.func.isRequired,
  rateViewerKey: PropTypes.string.isRequired,
  onConfigureLabel: PropTypes.func.isRequired,
  shipmentConfiguration: RateBrowserShipmentConfigurationPropType.isRequired,
  onScaleRead: PropTypes.func.isRequired,
};
